import normalizedSearchString from './normalizedSearchString.js';

export default function includesSearch(
  searchString: string,
  searchValue: string
) {
  return normalizedSearchString(searchString).includes(
    normalizedSearchString(searchValue)
  );
}
